import { Component, Input, Output, EventEmitter } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    templateUrl: "./change-password-modal.component.html",
    styleUrls: ["./change-password-modal.component.less"],
})
export class ChangePasswordModalComponent {
    constructor(public activeModal: NgbActiveModal) {}

    public closeModal(): void {
        this.activeModal.dismiss()
    }
}
